import { cn } from "@/utils";
import React from "react";

interface CenteredLayoutProps {
  children: React.ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export const CenteredLayout: React.FC<CenteredLayoutProps> = ({
  children,
  maxWidth = "lg",
  className,
}) => {
  const maxWidthClasses = {
    sm: "max-w-md",
    md: "max-w-2xl",
    lg: "max-w-4xl",
    xl: "max-w-6xl",
  };

  return (
    <div className="flex min-h-dvh w-full items-center justify-center bg-background py-10 px-4 sm:px-6 lg:px-8">
      <div className={cn("w-full", maxWidthClasses[maxWidth], className)}>
        {children}
      </div>
    </div>
  );
};
